import UserAvatar from "@/components/shared/UserAvatar";
import { Checkbox } from "@primitives/checkbox";

type Props = {
  username: string;
  checked: boolean;
  onChecked: (username: string, value: boolean) => void;
};

export default function MemberListItem({
  username,
  checked,
  onChecked,
}: Props) {
  return (
    <label
      className="flex items-center justify-start gap-3 truncate px-4 py-2 align-middle lg:cursor-pointer"
      htmlFor={username}
    >
      <UserAvatar username={username} className="size-8" />

      <h3 className="truncate">{username} </h3>
      <Checkbox
        className="ml-auto size-5 rounded-full"
        id={username}
        checked={checked}
        onCheckedChange={(value) => onChecked(username, value as boolean)}
      />
    </label>
  );
}
